import { AdvancedSearchFormModel } from "./../../models/advanced-search-form";
import { FieldName } from "./../../models/query-component";
import { AppInsights } from "applicationinsights-js";
import { Container } from "aurelia-dependency-injection";
import { SearchModel } from "./../../models/search";
import Marionette from "../../../shared/marionette-mustache";
import { AdvancedSearchFieldModel } from "../../../search/models/advanced-search-field";
import "jquery-ui/ui/widgets/datepicker";
import "jquery-ui/themes/base/theme.css";
import "jquery-ui/themes/base/datepicker.css";
import { AppEvents } from "../../../app-events";
import { ContainerHelper } from "../../../shared/helpers/container-helper";

const singleTextFieldTemplate = require<string>("../../../search/views/advanced-search/single-text-field.html");
const textAreaTemplate = require<string>("../../../search/views/advanced-search/textarea-field.html");
const yearRangeTemplate = require<string>("../../../search/views/advanced-search/year-range-field.html");
const dateRangeTemplate = require<string>("../../../search/views/advanced-search/date-range-field.html");
const helpTemplate = require<string>("./advanced-search-field-help.html");

const dom = {
    SEARCH_BOX: "#search-box",
    FORM_FIELD: ".form-field"
};

export class AdvancedSearchFieldView extends Marionette.ItemView<AdvancedSearchFieldModel> {

    private appEvents: Backbone.Events;

    private minDateYear = 1220;

    constructor(options?) {
        super(options);
        this.appEvents = ContainerHelper.Events;
        this.listenTo(this.model, "change:FieldValue", this.valueChanged);
        this.listenTo(this.model, "change:FieldValue2", this.value2Changed);
        this.listenTo(this.model, "change:ShowOnForm", this.showOnFormChanged);
        this.listenTo(this.model.AdvancedSearch, "scrolled", this.advancedSearchScrolled);
        this.listenTo(this.model.AdvancedSearch, "resized", this.advancedSearchScrolled);
        this.listenTo(this.model, "change:Disabled", this.disabledValueChanged);
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["keydown .form-field"] = (e) => this.keyDown(e);
        events["keyup .form-field"] = (e) => this.keyPressed(e);
        events["click .field-remover"] = (e) => this.fieldRemoverClicked(e);
        events["change .form-field"] = (e) => this.keyDown(e);
        return events;
    }

    public onShow() {
        _.defer(() => {
            this.setupPasteHandler();
            this.setupClickAndDragHandler();
            this.setupDatePickers();
            this.setupHelpPopover();
        });
    }

    public showOnFormChanged() {
        _.defer(() => {
            if (this.model.ShowOnForm) { // if we just added it to form
                $(`.form-field[data-field-name="${this.model.FieldName}"]`).focus();
            }
        });
    }

    public fieldRemoverClicked(e: JQueryEventObject) {
        const fieldId = $(e.currentTarget).data("field-id");
        this.model.removeField();
    }

    public keyDown(e: JQueryEventObject) {
        if ($(e.currentTarget).data("field-name").slice(-3) === "-to") {
            this.model.setField2Contents($(e.currentTarget).val());
        } else {
            this.model.setContents($(e.currentTarget).val());
        }
        this.model.announceKeyPress();
        $(dom.SEARCH_BOX).removeClass("search-cues-disabled");
    }

    public keyPressed(e: JQueryEventObject) {
        if (e.keyCode === 13 && this.model.TemplateName !== "TextArea") { // 13 is Enter. Don't register it as form submit in multi-line input
            this.model.AdvancedSearch.SearchModel.trigger("searchSubmit");
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
        this.keyDown(e);
    }

    public valueChanged(model, prop) {
        $(`[data-field-name="${this.model.FieldName}"]`).val(this.model.FieldValue);
        // Update the minimum attribute of Field2 if this is a 2 part field
        if ($(`[data-field-name="${this.model.FieldName}-to"]`).length) {
            this.setValue2Minimum(this.model.FieldValue);
        }
    }

    public value2Changed(model, prop) {
        if ($(`[data-field-name="${this.model.FieldName}-to"]`).length) {
            this.setValue1Maximum(this.model.FieldValue2);
            $(`[data-field-name="${this.model.FieldName}-to"]`).val(this.model.FieldValue2);
        }
    }

    public disabledValueChanged(model, prop) {
        $(`[data-field-name="${this.model.FieldName}"]`)
                                    .prop("disabled", prop)
                                    .prop("placeholder", this.model.PlaceHolderText);
    }

    public render() {
        if (!this.model.ShowOnForm) {
            return;
        }
        let templ: string;
        switch (this.model.TemplateName) {
            case "SingleTextField":
                templ = singleTextFieldTemplate;
                break;
            case "TextArea":
                templ = textAreaTemplate;
                break;
            case "YearRange":
                templ = yearRangeTemplate;
                break;
            case "DateRange":
                templ = dateRangeTemplate;
                break;
            default:
                return;
        }

        try {
            if (!templ) { return; }
            (this as any).template = templ;
            Marionette.ItemView.prototype.render.call(this);
        }
        catch (exception) {
            console.log(`Error rendering field: ${this.model.FieldName} with ${this.model.TemplateName}`);
        }
        return this;
    }

    private setupPasteHandler() {
        const self = this;  // need this for referencing inside the arrow function
        const $inputBox = this.$(dom.FORM_FIELD);
        $inputBox.on("paste", () => {
            _.defer(() => {
                self.$(dom.FORM_FIELD).trigger("keyup");
            });
        });
    }

    private setupClickAndDragHandler() {
        const $inputBox = this.$(dom.FORM_FIELD);
        $inputBox.bind("drop", () => {
            _.defer(() => {
                $(dom.FORM_FIELD).trigger("keyup"); // trigger this on all fields in case you're dragging from another field to this one
            });
        });
    }

    private setValue2Minimum(value: string) {
        let minDate = this.parseDate(value);
        const value2Date = this.$(`[data-field-name="${this.model.FieldName}-to"]`).datepicker("getDate");

        // Turn off validation if manually entering a non-validating date
        if (this.isBrokenDate(minDate) || (value2Date !== null && value2Date <= minDate)) {
            minDate = null;
        }

        this.$(`[data-field-name="${this.model.FieldName}-to"]`).datepicker("option", "minDate", minDate);
    }

    private setValue1Maximum(value: string) {
        let maxDate = this.parseDate(value);
        const value1Date = this.$(`[data-field-name="${this.model.FieldName}"]`).datepicker("getDate");

        // Turn off validation if manually entering a non-validating date
        if (this.isBrokenDate(maxDate) || (value1Date !== null && value1Date >= maxDate)) {
            maxDate = null;
        }

        this.$(`[data-field-name="${this.model.FieldName}"]`).datepicker("option", "maxDate", maxDate);
    }

    private parseDate(value: string) {
        let date: Date = null;

        try {
            const parts = value.split("/");

            if (parts.length === 3) {
                const year = parseInt(parts[2]);
                const month = parseInt(parts[1]) - 1;
                const day = parseInt(parts[0]) - 1;
                date = new Date(year, month, day);
            }
        } catch (err) {
            // fail silently
        }

        return date;
    }

    private isBrokenDate(value: Date): boolean {
        try {
            return isNaN(value.getTime());
        } catch (err) {
            return true;
        }
    }

    private setupDatePickers() {
        $(".form-field.date").datepicker({
             dateFormat: "dd/mm/yy",
             changeMonth: true,
             changeYear: true,
             yearRange: `${this.minDateYear}:${(new Date()).getFullYear()}`
        });
    }

    private setupHelpPopover() {
        const $icon = this.$(".field-help");
        $icon.popover({
            container: "#application-container",
            viewport: "#application-container",
            placement: "right",
            html: true,
            trigger: "manual",
            title: `${this.model.FieldLabel} Field`,
            content: () => this.getHelpPopoverContent()
        }).click((e) => {
            $(".field-help").popover("hide");
            this.appEvents.trigger(AppEvents.AppInsightsAdvancedSearchFieldHelp, { FieldName: this.model.FieldName, ActiveForm: this.model.AdvancedSearch.ActiveForm.Label });
            $icon.popover("toggle");

            $(document).off("click", ".field-feedback").on("click", ".field-feedback", (event) => {
                event.stopPropagation();
                this.appEvents.trigger(AppEvents.AppInsightsAdvancedSearchFieldHelpFeedback, { FieldName: this.model.FieldName, ActiveForm: this.model.AdvancedSearch.ActiveForm.Label, Feedback: $(event.currentTarget).data("feedback") });
                $(event.currentTarget).parent().html("Thanks for the feedback.");
                return false; // don"t refresh the page, please
            });

            return false;
        });
    }

    private getHelpPopoverContent() {
        const html = Mustache.render(helpTemplate, this.model.Help);
        return html;
    }

    private advancedSearchScrolled() {
        this.$(".field-help").popover("hide");
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/advanced-search/advanced-search-field.ts